/* eslint-disable */
import React, { useState } from 'react';
import Header from './components/Header/header';
import Footer from './components/Footer/footer';
import Home from './components/Home/home';
import Services from './components/Services/services';
import News from './components/News/News';
import Resources from './components/Resources/Resources';
import Transparency from './components/Transparency/Transparency';
import Contact from './components/Contact/Contact';
import Gallery from './components/Gallery/Gallery';
import AboutUs from './components/About/about';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'about': return <AboutUs />;
      case 'services': return <Services />;
      case 'news': return <News />;
      case 'resources': return <Resources />;
      case 'transparency': return <Transparency />;
      case 'contact': return <Contact />;
      case 'gallery': return <Gallery />;
      default: return <Home currentPage={currentPage} setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="App">
      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <main>
        {renderPage()}
      </main>
      <Footer currentPage={currentPage} setCurrentPage={setCurrentPage}/>
    </div>
  );
}

export default App;

//dev by GraBit Technologies//